import React,{useState} from 'react'
import CampaignTable from './CampaignTable'
import TabContent from '../common/tabs/TabContent'
import TabNavItem from '../common/tabs/TabNavItem'
import CampaignTemplates from './CampaignTemplates'

function Campaign() {
  const [activeTab,setActiveTab] = useState('campaign-table')
  return (
   <>
    <div className="container container-xxl">
         <div className="pagetitle d-flex justify-content-between">
                  <h1>Campaigns</h1>
        </div>
        <div>
           <nav className="nav nav-tabs" >
              <TabNavItem 
                 id="campaign-table"
                 title="Campaign List"
                 icon="bi bi-table"
                 activeTab={activeTab}
                 setActiveTab={setActiveTab}
              />
               <TabNavItem 
                 id="template-table"
                 title="Template"
                 icon="bi bi-card-heading"
                 activeTab={activeTab}
                 setActiveTab={setActiveTab}
              />
            </nav>
            <div className="tab-content pt-2" style={{width:'100%'}}>
                    <TabContent id="campaign-table" activeTab={activeTab}>
                      <div className="card">
                        <div className="card-body p-2">
                        <CampaignTable/>
                        </div>
                      </div>
                    </TabContent>
                    <TabContent id="template-table" activeTab={activeTab}>
                        <CampaignTemplates/>
                    </TabContent>
            </div>
        </div>
       
       
    </div>
   </>
  )
}

export default Campaign